import React from 'react'

export const Privacy = () => {
  return <div>Privacy</div>
}
